import logger from '@getgo/logger';
import globalErrorHandler from '@getgo/logger/inputs/global_error_handler';
import loggerTargetLoggingServicePlugin from '@getgo/logger-target-logging-service';
import windowUtils from '@/utils/window-utils';

const fixed = {
  context: {
    ls_source: 'g2w-client',
    ls_sourcetype: 'logging'
  }
};

function createLogger() {
  const loggerTargetLoggingService = loggerTargetLoggingServicePlugin();

  const theLogger = logger.createRoot(loggerTargetLoggingService);

  theLogger.startLoggingService = (params) => loggerTargetLoggingService.start({...params, ...fixed});

  // todo: rethrowErrors in live environment?
  globalErrorHandler.setup(window, theLogger, { rethrowErrors: true });

  function beforeUnloadHandler() {
    theLogger.flush.call(theLogger);
  }

  // 'unload' doesn't always (ever?) get called, resort to 'beforeunload'
  windowUtils.addEventListener('beforeunload', beforeUnloadHandler);

  return theLogger;
}

const rootLogger = createLogger();
export default rootLogger;
